import React from "react";

const ProductCardSkeleton = ({ viewMode = "grid" }) => {
  if (viewMode === "list") {
    return (
      <div className="bg-surface border border-border rounded-lg p-4 animate-pulse">
        <div className="flex items-center space-x-4">
          <div className="w-20 h-20 bg-secondary-200 rounded-lg flex-shrink-0"></div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="h-4 bg-secondary-200 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-secondary-200 rounded w-1/2 mb-3"></div>
                <div className="h-3 bg-secondary-200 rounded w-1/3 mb-2"></div>
                <div className="flex space-x-2">
                  <div className="h-6 bg-secondary-200 rounded w-16"></div>
                  <div className="h-6 bg-secondary-200 rounded w-20"></div>
                </div>
              </div>

              <div className="text-right ml-4">
                <div className="h-6 bg-secondary-200 rounded w-16 mb-2"></div>
                <div className="h-4 bg-secondary-200 rounded w-12 mb-2"></div>
                <div className="h-6 bg-secondary-200 rounded w-20"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface border border-border rounded-lg overflow-hidden animate-pulse">
      <div className="aspect-square bg-secondary-200"></div>

      <div className="p-4">
        <div className="h-4 bg-secondary-200 rounded w-3/4 mb-2"></div>
        <div className="h-3 bg-secondary-200 rounded w-1/2 mb-3"></div>
        <div className="h-3 bg-secondary-200 rounded w-1/3 mb-3"></div>
        <div className="flex space-x-2 mb-3">
          <div className="h-6 bg-secondary-200 rounded w-16"></div>
          <div className="h-6 bg-secondary-200 rounded w-20"></div>
        </div>
        <div className="flex items-center justify-between">
          <div>
            <div className="h-6 bg-secondary-200 rounded w-16 mb-1"></div>
            <div className="h-4 bg-secondary-200 rounded w-12"></div>
          </div>
          <div className="w-8 h-8 bg-secondary-200 rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
